import apiClient from "@/app/api/client";
import { equipmentEndpoints, replaceParams } from "@/app/api/endpoints";
import type {
	CreateEquipmentRequest,
	Equipment,
	EquipmentGpsResponse,
	EquipmentListParams,
	EquipmentPaginatedResponse,
	LiveEquipmentPosition,
	LiveGpsParams,
	LiveGpsResponse,
	SuccessResponse,
	UpdateEquipmentRequest,
} from "../types";

export const equipmentService = {
	async list(params?: EquipmentListParams): Promise<EquipmentPaginatedResponse> {
		const response = await apiClient.get<EquipmentPaginatedResponse>(equipmentEndpoints.list, {
			params,
		});
		return response.data;
	},

	async getById(id: string): Promise<Equipment> {
		const url = replaceParams(equipmentEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<Equipment>>(url);
		return response.data.data;
	},

	async create(data: CreateEquipmentRequest): Promise<Equipment> {
		const response = await apiClient.post<SuccessResponse<Equipment>>(
			equipmentEndpoints.create,
			data
		);
		return response.data.data;
	},

	async update(id: string, data: UpdateEquipmentRequest): Promise<Equipment> {
		const url = replaceParams(equipmentEndpoints.update, { id });
		const response = await apiClient.put<SuccessResponse<Equipment>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(equipmentEndpoints.delete, { id });
		await apiClient.delete(url);
	},

	async getGps(id: string): Promise<EquipmentGpsResponse> {
		const url = replaceParams(equipmentEndpoints.gpsHistory, { id });
		const response = await apiClient.get<SuccessResponse<EquipmentGpsResponse>>(url);
		return response.data.data;
	},

	async getLive(params?: LiveGpsParams): Promise<LiveEquipmentPosition[]> {
		const response = await apiClient.get<LiveGpsResponse>(equipmentEndpoints.live, { params });
		return response.data.data;
	},
};
